import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { agentAxiosObj, axiosObj } from "../../config/apiClients";
import { getActorTypeFromHost } from "../../utils/helpers/getActorType";
import { KycState } from "../types";

// The admin portal lists every real customer; the sales agent portal only the agent's own clients.
const kycListApi =
  getActorTypeFromHost() === "salesAgent"
    ? { client: agentAxiosObj, path: "kyc" }
    : { client: axiosObj, path: "compliance/kyc" };

const initialPagination = {
  totalItems: 0,
  currentPage: 1,
  totalPages: 1,
  hasNextPage: false,
};

const initialState: KycState = {
  isLoading: false,
  documents: [],
  pagination: initialPagination,
};

export const getKycDocuments = createAsyncThunk(
  "/kyc/documents",
  async (
    query: {
      paramPage: number;
      paramLimit: number;
      search?: string;
      expiryStatus?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      params.set("paramPage", query.paramPage.toString());
      params.set("paramLimit", query.paramLimit.toString());
      if (query.search) params.set("search", query.search);
      if (query.expiryStatus && query.expiryStatus !== "All")
        params.set("expiryStatus", query.expiryStatus);
      const response = await kycListApi.client.get(`${kycListApi.path}?${params.toString()}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: "Failed to Fetch KYC Documents" });
    }
  }
);

const kycSlice = createSlice({
  name: "kyc",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getKycDocuments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getKycDocuments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.documents = action.payload.payload.documents;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage,
        };
      })
      // An empty result / 404 lands here — an empty list is the right state.
      .addCase(getKycDocuments.rejected, (state) => {
        state.isLoading = false;
        state.documents = [];
        state.pagination = initialPagination;
      });
  },
});

export default kycSlice.reducer;
